import { render, staticRenderFns } from "./WhatsappAuditPanel.vue?vue&type=template&id=dc8ea48c&scoped=true&lang=pug"
import script from "./WhatsappAuditPanel.vue?vue&type=script&lang=js"
export * from "./WhatsappAuditPanel.vue?vue&type=script&lang=js"
import style0 from "./WhatsappAuditPanel.vue?vue&type=style&index=0&id=dc8ea48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8ea48c",
  null
  
)

export default component.exports